import { atom } from 'jotai';

// A value of 0 indicates that no protection plan is selected
const pdpSelectedProtectionPlanIdAtom = atom(0);

export default pdpSelectedProtectionPlanIdAtom;
